import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';
import { config } from '../../config';
import {
  CreateEmployeesFilesZip,
  GetEmployeesFilesZipStatus,
} from '../../models/EmployeeFiles';

interface IEmployeeFilesService {
  createEmployeesFilesZip: (
    year: number,
    month: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<CreateEmployeesFilesZip>>;

  getEmployeesFilesZipStatusUrl: (
    archiveId: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<GetEmployeesFilesZipStatus>>;

  downloadEmployeesFiles: (
    archiveId: string,
    archiveName: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<null>>;
}

export const employeeFilesService: IEmployeeFilesService = {
  createEmployeesFilesZip(year, month, axiosConfig) {
    return ajax.post<CreateEmployeesFilesZip>(
      `${config.benefitApiUrl}/create-employees-files-zip?year=${year}&month=${month}`,
      axiosConfig,
    );
  },

  getEmployeesFilesZipStatusUrl(archiveId, axiosConfig) {
    return ajax.get<GetEmployeesFilesZipStatus>(
      `${config.benefitApiUrl}/employees-files-zip-status?archiveId=${archiveId}`,
      axiosConfig,
    );
  },

  downloadEmployeesFiles(archiveId, archiveName, axiosConfig) {
    return ajax.downloadFile(
      `${config.benefitApiUrl}/download-employees-files-zip?archiveId=${archiveId}`,
      archiveName,
      'zip',
      axiosConfig,
    );
  },
};
